module.exports = __webpack_public_path__ + "static/media/shaker.de427ed6.png";